import _ from 'lodash'
import store from '@ps/store'
import * as nodeUtils from '@ps/store/workbench/common/node-utils'
import {
  getTweenPositionData,
  setAdpaterData,
} from '@ps/bridge/qc/scripts/vertical-horizontal'
import { builtinScript } from '@ps/utils/config'
import { isFirstLevelNodeInScene, isIvGroup } from '@ps/bridge/qc/base'
import { findByUuid } from '@ps/bridge/qc/node/utils'
import { updateAnimation } from '@ps/store/workbench/common/animation'
import { Event, EventBus } from '@ps/utils/event-bus'
import { calcPositionByLayoutData } from '@ps/bridge/qc/scripts/layout'
import { updateAnotherResolutionLayout } from '@ps/store/workbench/common/layout'
import { getScreenAdapter } from '@ps/bridge/qc/scripts/editor'
import { generateLayoutData } from '@ps/bridge/qc/scripts/layout'
import { getUnSplitPropValue } from '@ps/bridge/qc/scripts/editor'
import { language } from '@/common/storage'
import { scripts } from '@ps/bridge/qc/scripts'
import gameIframe from '@ps/bridge/iframe/iframe'

/**
 * 添加动画到节点
 * @param node
 * @param animations 支持预设动画配置参数、以及从节点中提取的动画脚本
 */
export function addBuiltinAnimation({ node, animations }) {
  if (!_.isArray(animations)) {
    animations = [animations]
  }
  const components = []
  const qc = store.state.workspace.game.data
  // 多个动画
  animations.forEach((animation) => {
    animation = _.cloneDeep(animation)
    const className = animation.class_name || animation.class
    const component = node.addScript(className)
    component.animationClassName = className
    component.addType = 1
    component.playOnAwake = true
    // 如果是复制动画，需要缓存起unSplitPropValue和verticalHorizontal里的adapterData数据用于复制动画的横竖屏拆分的数据
    if (animation.gameObject) {
      if (className === 'qc.TweenPosition') {
        component.unSplitPropValue = getUnSplitPropValue(
          animation.gameObject,
          `tweenPosition-${animation.uuid}`,
        )
        const vh = animation.gameObject.getScript(
          scripts.verticalHorizontal.name,
        )
        if (vh && vh.adapterData && vh.adapterData.tweenPosition) {
          component.adapterData = vh.adapterData.tweenPosition[animation.uuid]
        }
      } else if (className === 'qc.TweenScale') {
        component.unSplitPropValue = getUnSplitPropValue(
          animation.gameObject,
          `tweenScale-${animation.uuid}`,
        )
        const vh = animation.gameObject.getScript(
          scripts.verticalHorizontal.name,
        )
        if (vh && vh.adapterData && vh.adapterData.tweenScale) {
          component.adapterData = vh.adapterData.tweenScale[animation.uuid]
        }
      }
    }

    // 初始化旋转曲线的to
    if (className === 'qc.TweenRotation') {
      component.to = 6.28
    }
    if (animation.builtinId) {
      // 预设id 添加爱预设分类后缀，用于layout修复动画横竖屏问题
      component.builtinId = `${animation.builtinId}___${getAnimationType(
        animation.builtinGroup,
      )}`
      animation.builtinId = component.builtinId
      component.builtinGroup = animation.builtinGroup
    }
    const list = [
      'curve',
      'style',
      'delay',
      'duration',
      'playOnAwake',
      'from',
      'to',
      'moveAxis',
    ]
    list.forEach((val) => {
      if (typeof animation[val] !== 'undefined') {
        if (val === 'curve') {
          component[val].keys = animation[val].keys
        } else if (
          (className === 'qc.TweenScale' || className === 'qc.TweenPosition') &&
          (val === 'to' || val === 'from')
        ) {
          component[val].x = animation[val].x
          component[val].y = animation[val].y
        } else if (
          className === 'qc.TweenColor' &&
          (val === 'to' || val === 'from') &&
          typeof animation[val] === 'string'
        ) {
          component[val] = new qc.Color(animation[val])
        } else {
          component[val] = animation[val]
        }
      }
    })
    // 添加位移动画，当动画本身带偏移参数，需要在节点x，y基础上增加偏移值
    if (className === 'qc.TweenPosition') {
      const hasOffset = animation.from || animation.to
      const offsetX = hasOffset ? animation.to.x - animation.from.x : 0
      const offsetY = hasOffset ? animation.to.y - animation.from.y : 0
      if (
        animation.builtinId &&
        getAnimationType(animation.builtinGroup) === 1
      ) {
        component.from.x = node.x - offsetX
        component.from.y = node.y - offsetY
        component.to.x = node.x
        component.to.y = node.y
      } else {
        component.from.x = node.x
        component.from.y = node.y
        component.to.x = node.x + offsetX
        component.to.y = node.y + offsetY
      }
    }
    const getAnimationName = (animation) => {
      const _default = '新建动画'
      const getLangName = (obj) => {
        return setAnimationName({
          name: obj.name || _default,
          name_en: obj.name_en || _default,
        })
      }

      let temp = ''
      if (!animation.builtinId) {
        temp = builtinScript.find((item) => item.class_name === animation.class)
        return getLangName(temp)
      }
      const list = store.state.workspace.animation.builtinList
      list.forEach((item) => {
        if (item.children) {
          item.children.forEach((el) => {
            if (
              el.assets &&
              el.assets.find((asset) => asset.id === animation.builtinGroup)
            ) {
              temp = el.assets.find(
                (asset) => asset.id === animation.builtinGroup,
              )
            }
          })
        }
      })
      return getLangName(temp)
    }
    component.animationName = `${getAnimationName(component)}`
    components.push(component)
  })
  return components
}

export function getAnimationType(id) {
  let type
  const list = store.state.workspace.animation.builtinList
  list.forEach((item) => {
    if (item.children) {
      item.children.forEach((el) => {
        if (el.assets && el.assets.some((asset) => asset.id === Number(id))) {
          type = item.cat_id
        }
      })
    }
  })
  return type
}

export function creatBuiltinItem(list, animation) {
  const last = list[list.length - 1]
  if (last && last.builtinId && last.builtinId === animation.builtinId) {
    last.group.push(animation)
  } else {
    list.push({
      ..._.pick(animation, [
        'builtinId',
        'builtinGroup',
        'duration',
        'playOnAwake',
        'delay',
        'animationName',
        'style',
      ]),
      group: [animation],
      uuid: animation.builtinId,
    })
  }
}

/**
 * 根据插入动画更新非当前屏幕方向下对应节点layout信息
 * @param {*} node
 * @param {*} animation
 * @param {*} type delete 为移除动画，add 添加动画
 */
export function updateResolutionNodeLayoutByAnimation({
  node,
  animation,
  type,
}) {
  const anotherResolution = store.state.workspace.game.device.anotherResolution
  // 如果含有另外一个分辨率的位移动画信息，需要按照另外一个分辨率的属性值进行计算偏移值
  const otherTpData = getTweenPositionData(
    node,
    animation.uuid,
    anotherResolution,
  )
  // 获取另外一个分辨率的 x/y
  const { x, y } = calcPositionByLayoutData(node, anotherResolution)
  const isInCome =
    animation.builtinId && getAnimationType(animation.builtinGroup) === 1
  // from不是layout位置
  const fromNotLayout =
    otherTpData && (otherTpData.from.x !== x || otherTpData.from.y !== y)
  // 是否拆分
  const isApart = !getUnSplitPropValue(node, `tweenPosition-${animation.uuid}`)
  // 因为另外一个分辨率的 x/y 都是 from 的值，需要更新为 to 的值
  const localPos = {
    x,
    y,
  }
  // 进场动画且存在适配数据
  if (isInCome && fromNotLayout && (!isApart || !otherTpData)) {
    localPos.x = x - (animation.to.x - animation.from.x)
    localPos.y = y - (animation.to.y - animation.from.y)
  } else if (isApart && isInCome && otherTpData && fromNotLayout) {
    localPos.x = x - (otherTpData.to.x - otherTpData.from.x)
    localPos.y = y - (otherTpData.to.y - otherTpData.from.y)
  }
  // 更新另外一个分辨率的 layout 信息
  updateAnotherResolutionLayout({
    node: node,
    anotherResolution,
    localPos,
  })
}

export function recoverPropToDefault({ animation, node }) {
  const qc = store.state.workspace.game.data
  const classPropMap = [
    {
      class: 'qc.TweenPosition',
      callback: () => {
        // 获取第一个动画
        const ani = node.scripts.find(
          (item) => item.class === 'qc.TweenPosition',
        )
        const anotherResolution =
          store.state.workspace.game.device.anotherResolution
        const data = {
          uuid: node.uuid,
        }
        // 存在首个位移动画，恢复到首个位移动画的from
        if (ani) {
          data.x = ani.from.x
          data.y = ani.from.y
        } else {
          // 根据移除动画类型判断
          // 移除动画为进场预设
          if (
            animation.builtinId &&
            getAnimationType(animation.builtinGroup) === 1
          ) {
            // 如果是进场动画，需要把元素回滚到进场动画的 to 位置
            data.x = animation.to.x
            data.y = animation.to.y
          } else {
            data.x = animation.from.x
            data.y = animation.from.y
          }
        }
        // 更新另一个屏幕位置
        const localPos = {}
        const otherTpData = getTweenPositionData(
          node,
          ani ? ani.uuid : animation.uuid,
          anotherResolution,
        )
        if (!otherTpData) {
          console.log('未发现可恢复适配信息')
          return
        }
        // 存在首个位移动画，恢复到首个位移动画的from
        if (ani) {
          localPos.x = otherTpData.from.x
          localPos.y = otherTpData.from.y
        } else {
          // 根据移除动画类型判断
          // 移除动画为进场预设
          if (
            animation.builtinId &&
            getAnimationType(animation.builtinGroup) === 1
          ) {
            // 如果是进场动画，需要把元素回滚到进场动画的 to 位置
            localPos.x = otherTpData.to.x
            localPos.y = otherTpData.to.y
          } else {
            localPos.x = otherTpData.from.x
            localPos.y = otherTpData.from.y
          }
        }
        // 保证设置style置于最后，修改style值触发更新适配信息
        nodeUtils.updateNodesStyle({
          nodes: [data],
        })
        // 更新另外一个分辨率的 layout 信息
        updateAnotherResolutionLayout({
          node: node,
          anotherResolution,
          localPos,
        })
      },
    },
    {
      class: 'qc.TweenRotation',
      callback: () => {
        nodeUtils.updateNodesStyle({
          nodes: [
            {
              uuid: node.uuid,
              rotation: 0,
            },
          ],
        })
      },
    },
    {
      class: 'qc.TweenScale',
      callback: () => {
        nodeUtils.updateNodesStyle({
          nodes: [
            {
              uuid: node.uuid,
              scaleX: 1,
              scaleY: 1,
            },
          ],
        })
      },
    },
    {
      class: 'qc.TweenAlpha',
      callback: () => {
        nodeUtils.updateNodesStyle({
          nodes: [
            {
              uuid: node.uuid,
              alpha: 1,
            },
          ],
        })
      },
    },
    {
      class: 'qc.TweenColor',
      callback: () => {
        updateAnimation({
          animations: [
            {
              uuid: animation.uuid,
              from: new qc.Color('#ffffff'), // 颜色值
            },
          ],
          node,
        })
        node.scripts
          .find((item) => item.uuid === animation.uuid)
          .resetToBeginning(false)
        EventBus.$emit(Event.ANIMATION_UPDATE)
      },
    },
  ]
  const method = classPropMap.find((item) => item.class === animation.class)
  if (method) {
    method.callback()
  }
}

export function updateAdapterData({ x, y, uuid, prop, node, adapter }) {
  adapter = adapter || store.state.workspace.game.device.adapterResolution
  const anotherResolution = store.state.workspace.game.device.anotherResolution
  // 记录动画参数，只记录x，y信息
  const curNode = node || store.state.workspace.game.activeNode
  const posData = { x: x, y: y }
  // 互动视频组组节点内的普通元素相当于ps里的一级节点一样
  if (isIvGroup(curNode.parent) || isFirstLevelNodeInScene(curNode)) {
    posData.rootWidth =
      anotherResolution === adapter
        ? curNode.parent.height
        : curNode.parent.width
    posData.rootHeight =
      anotherResolution === adapter
        ? curNode.parent.width
        : curNode.parent.height
  }
  setAdpaterData(curNode, `tweenPosition.${uuid}.${prop}`, posData, adapter)
}

export function setPlayedTweenAdpaterData({ node, uuid, localP, localPFrom }) {
  const resolutions = [
    store.state.workspace.game.device.adapterResolution,
    store.state.workspace.game.device.anotherResolution,
  ]
  resolutions.forEach((resolution, index) => {
    const screenAdapter = getScreenAdapter(node, resolution)
    const newLayoutData = generateLayoutData({
      node: node,
      resolution: resolution,
      horizontal: screenAdapter.horizontal,
      vertical: screenAdapter.vertical,
      forcedValue: {
        x: localP[index].x,
        y: localP[index].y,
      },
    })
    setAdpaterData(
      node,
      `tweenPosition.${uuid}.tweenLayout`,
      newLayoutData,
      resolution,
    )
  })
  // 记录起始点的数据
  resolutions.forEach((resolution, index) => {
    const screenAdapter = getScreenAdapter(node, resolution)
    const newLayoutData = generateLayoutData({
      node: node,
      resolution: resolution,
      horizontal: screenAdapter.horizontal,
      vertical: screenAdapter.vertical,
      forcedValue: {
        x: localPFrom[index].x,
        y: localPFrom[index].y,
      },
    })
    setAdpaterData(
      node,
      `tweenPosition.${uuid}.tweenLayoutFrom`,
      newLayoutData,
      resolution,
    )
  })
}

export function updatePositionTween(node) {
  const anotherResolution = store.state.workspace.game.device.anotherResolution
  // 调用来源可能存在proxy节点，需要重新获取源节点
  const targetNode = findByUuid(node.uuid)
  if (!targetNode) return
  const tweens = targetNode.scripts.filter(
    (item) => item.class === 'qc.TweenPosition',
  )
  // 更新动画座标信息
  tweens.forEach((tween, index) => {
    const offset = {
      x: tween.to.x - tween.from.x,
      y: tween.to.y - tween.from.y,
    }
    if (index === 0) {
      // 0318修改，原来的赋值方式有引用关系，赋值第一个tween的to时后面的tween的from也被跟着赋值。这里重新new一个point出来，不同tween的from和to应该是独立没有引用关系的
      tween.from = new gameIframe.qc.Point(targetNode.x, targetNode.y)
      tween.to = new gameIframe.qc.Point(
        targetNode.x + offset.x,
        targetNode.y + offset.y,
      )
      updateResolutionNodeLayoutByAnimation({
        animation: tween,
        node,
      })
    } else {
      tween.from = new gameIframe.qc.Point(
        tweens[index - 1].to.x,
        tweens[index - 1].to.y,
      )
      tween.to = new gameIframe.qc.Point(
        tweens[index - 1].to.x + offset.x,
        tweens[index - 1].to.y + offset.y,
      )
    }

    // 记录动画适配信息坐标值
    updateAdapterData({
      x: tween['from'].x,
      y: tween['from'].y,
      uuid: tween.uuid,
      prop: 'from',
      node: targetNode,
    })
    updateAdapterData({
      x: tween['to'].x,
      y: tween['to'].y,
      uuid: tween.uuid,
      prop: 'to',
      node: targetNode,
    })
    const tempData = {
      from: {
        x: '',
        y: '',
      },
      to: {
        x: '',
        y: '',
      },
    }
    // 更新另外屏幕适配信息
    const updateOtherAdapterData = () => {
      // 是否拆分动画
      const isApart = !getUnSplitPropValue(node, `tweenPosition-${tween.uuid}`)
      if (isApart) {
        // 拆分
        // 如果含有另外一个分辨率的位移动画信息，需要按照另外一个分辨率的属性值进行计算偏移值
        const otherTpData = getTweenPositionData(
          node,
          tween.uuid,
          anotherResolution,
        )
        // 获取另外一个分辨率的 x/y
        const { x, y } = calcPositionByLayoutData(node, anotherResolution)
        if (otherTpData) {
          // 有适配数据
          const offset = {
            x: otherTpData.to.x - otherTpData.from.x,
            y: otherTpData.to.y - otherTpData.from.y,
          }
          if (index === 0) {
            tempData.from.x = x
            tempData.from.y = y
            tempData.to.x = x + offset.x
            tempData.to.y = y + offset.y
          } else {
            // 获取上一个tween数据
            const lastOtherTpData = getTweenPositionData(
              node,
              tweens[index - 1].uuid,
              anotherResolution,
            )
            tempData.from.x = lastOtherTpData.to.x
            tempData.from.y = lastOtherTpData.to.y
            tempData.to.x = lastOtherTpData.to.x + offset.x
            tempData.to.y = lastOtherTpData.to.y + offset.y
          }
        } else {
          // 无适配数据
          const offset = {
            x: tween.to.x - tween.from.x,
            y: tween.to.y - tween.from.y,
          }
          if (index === 0) {
            tempData.from.x = x
            tempData.from.y = y
            tempData.to.x = x + offset.x
            tempData.to.y = y + offset.y
          } else {
            tempData.from.x = tweens[index - 1].to.x
            tempData.from.y = tweens[index - 1].to.y
            tempData.to.x = tweens[index - 1].to.x + offset.x
            tempData.to.y = tweens[index - 1].to.y + offset.y
          }
        }
      } else {
        // 不拆分
        // 获取另外一个分辨率的 x/y
        const { x, y } = calcPositionByLayoutData(node, anotherResolution)
        // 有适配数据
        const offset = {
          x: tween.to.x - tween.from.x,
          y: tween.to.y - tween.from.y,
        }
        if (index === 0) {
          tempData.from.x = x
          tempData.from.y = y
          tempData.to.x = x + offset.x
          tempData.to.y = y + offset.y
        } else {
          // 获取上一个tween数据
          const lastOtherTpData = getTweenPositionData(
            node,
            tweens[index - 1].uuid,
            anotherResolution,
          )
          tempData.from.x = lastOtherTpData.to.x
          tempData.from.y = lastOtherTpData.to.y
          tempData.to.x = lastOtherTpData.to.x + offset.x
          tempData.to.y = lastOtherTpData.to.y + offset.y
        }
        // tempData.from = {
        //   ...tween['from'],
        // }
        // tempData.to = {
        //   ...tween['to'],
        // }
      }
      updateAdapterData({
        x: tempData['from'].x,
        y: tempData['from'].y,
        uuid: tween.uuid,
        prop: 'from',
        node: targetNode,
        adapter: anotherResolution,
      })
      updateAdapterData({
        x: tempData['to'].x,
        y: tempData['to'].y,
        uuid: tween.uuid,
        prop: 'to',
        node: targetNode,
        adapter: anotherResolution,
      })
    }
    updateOtherAdapterData()
    setPlayedTweenAdpaterData({
      node: targetNode,
      uuid: tween.uuid,
      localP: [
        {
          x: tween.to.x,
          y: tween.to.y,
        },
        {
          x: tempData.to.x,
          y: tempData.to.y,
        },
      ],
      localPFrom: [
        {
          x: tween.from.x,
          y: tween.from.y,
        },
        {
          x: tempData.from.x,
          y: tempData.from.y,
        },
      ],
    })
  })
}

export function updateAdapterDataScale({ x, y, uuid, prop, node, adapter }) {
  adapter = adapter || store.state.workspace.game.device.adapterResolution
  // 记录动画参数，只记录x，y信息
  const curNode = node || store.state.workspace.game.activeNode
  const posData = { x: x, y: y }
  setAdpaterData(curNode, `tweenScale.${uuid}.${prop}`, posData, adapter)
}

export function setPlayedTweenScaleAdpaterData({
  node,
  uuid,
  dataFrom,
  data,
  both,
}) {
  const resolutions = [
    store.state.workspace.game.device.adapterResolution,
    store.state.workspace.game.device.anotherResolution,
  ]
  resolutions.forEach((resolution, index) => {
    if (!both && index === 1) return
    const screenAdapter = getScreenAdapter(node, resolution)
    const newLayoutData = generateLayoutData({
      node: node,
      resolution: resolution,
      horizontal: screenAdapter.horizontal,
      vertical: screenAdapter.vertical,
      forcedValue: {
        scaleX: data.x,
        scaleY: data.y,
      },
    })
    setAdpaterData(
      node,
      `tweenScale.${uuid}.tweenLayout`,
      newLayoutData,
      resolution,
    )
  })
  // 记录起始点的数据
  resolutions.forEach((resolution, index) => {
    if (!both && index === 1) return
    const screenAdapter = getScreenAdapter(node, resolution)
    const newLayoutData = generateLayoutData({
      node: node,
      resolution: resolution,
      horizontal: screenAdapter.horizontal,
      vertical: screenAdapter.vertical,
      forcedValue: {
        scaleX: dataFrom.x,
        scaleY: dataFrom.y,
      },
    })
    setAdpaterData(
      node,
      `tweenScale.${uuid}.tweenLayoutFrom`,
      newLayoutData,
      resolution,
    )
  })
}

export function updateScaleTween(node, bothResolution) {
  const anotherResolution = store.state.workspace.game.device.anotherResolution
  // 调用来源可能存在proxy节点，需要重新获取源节点
  const targetNode = findByUuid(node.uuid)
  if (!targetNode) return
  const tweens = targetNode.scripts.filter(
    (item) => item.class === 'qc.TweenScale',
  )
  // 更新动画座标信息
  tweens.forEach((tween, index) => {
    // 记录动画适配信息坐标值
    updateAdapterDataScale({
      x: tween['from'].x,
      y: tween['from'].y,
      uuid: tween.uuid,
      prop: 'from',
      node: targetNode,
    })
    updateAdapterDataScale({
      x: tween['to'].x,
      y: tween['to'].y,
      uuid: tween.uuid,
      prop: 'to',
      node: targetNode,
    })
    let both = false
    const isApart = !getUnSplitPropValue(node, `tweenScale-${tween.uuid}`)
    if (bothResolution || !isApart) {
      both = true
      updateAdapterDataScale({
        x: tween['from'].x,
        y: tween['from'].y,
        uuid: tween.uuid,
        prop: 'from',
        node: targetNode,
        adapter: anotherResolution,
      })
      updateAdapterDataScale({
        x: tween['to'].x,
        y: tween['to'].y,
        uuid: tween.uuid,
        prop: 'to',
        node: targetNode,
        adapter: anotherResolution,
      })
    }
    setPlayedTweenScaleAdpaterData({
      node: targetNode,
      uuid: tween.uuid,
      dataFrom: {
        x: tween.from.x,
        y: tween.from.y,
      },
      data: {
        x: tween.to.x,
        y: tween.to.y,
      },
      both,
    })
  })
}

// 获取动画名称，由于动画名称需要支持国际化，所以动画名称存储改成 json 字符串，如果能解析出 json 字符串，则返回 json 对象中对应语言的文案，否则返回字符串
export function getAnimationName(animationName, lang) {
  const currentLang = lang || language.get()
  try {
    const json = JSON.parse(animationName)
    if (currentLang === 'en') {
      return json.en
    }
    return json['zh-cn']
  } catch (error) {
    // 该名称不是 json 字符串
    return animationName
  }
}

export function setAnimationName({ animationName, name, name_en }) {
  let json = {}
  if (typeof animationName !== 'undefined') {
    try {
      json = JSON.parse(animationName)
    } catch (error) {
      console.log('该名称不是 json 字符串, 需要重置', error)
    }
  }
  if (typeof name !== 'undefined') {
    json['zh-cn'] = name
  }
  if (typeof name_en !== 'undefined') {
    json['en'] = name_en
  }
  return JSON.stringify(json)
}
